import React from "react";
import Header from "../../_legacy/Containers/Guest/Header.js";
import Footer from "../../_legacy/Containers/Guest/Footer.js";
import { DEFAULT_IP_API_URL } from "../../consts/network";

class BlockIP extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ip: window?.AR_IP_ADDRESS || "" };
  }

  componentDidMount() {
    if (!this.state.ip) {
      fetch(DEFAULT_IP_API_URL)
        .then((res) => res.json())
        .then((data) => {
          if (data.ip) this.setState({ ip: data.ip });
        })
        .catch(() => {});
    }
  }

  render() {
    return (
      <div className="guest">
        <Header />
        <div className="thanku">
          <h1>Unable to log in due to a blocked IP address.</h1>
          <h3>
            Please contact AR Support and provide your IP address{" "}
            {this.state.ip && `IP ${this.state.ip}`}.
            <br />
            <a href="mailto:support@aestheticrecord.com">
              support@aestheticrecord.com
            </a>
          </h3>
        </div>
        <Footer />
      </div>
    );
  }
}

export default BlockIP;
